import { Component, Host, h, Prop, JSX, Element } from '@stencil/core'

@Component({
    tag: 'zr-accordion-group',
    styleUrl: 'zr-accordion-group.scss',
    scoped: true,
})

/**
 * ZooRoyal accordion component.
 */
export class ZrAccordionGroup {
    @Element() el: HTMLElement

    /**
     * The information that is displayed.
     */
    @Prop() data: Array<{ title: string, content: string }>

    /**
     * Prop to identify the index of the active accordion.
     */
    @Prop({ mutable: true }) activeIndex? = 0

    /**
     * Toggles the state of a single accordion element and scrolls to it.
     *
     * @param {number} index
     */
    private toggleActiveState = (index) => {
        if (this.activeIndex === index) {
            this.activeIndex = null
        } else {
            this.activeIndex = index
            this.scrollAccordionIntoView()
        }
    }

    /**
     * Scroll the accordion-group into the viewport.
     */
    private scrollAccordionIntoView = () => {
        this.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                {this.data.map((element, index) => (
                    <zr-accordion
                        onActiveStateToggled={() => {
                            this.toggleActiveState(index)
                        }}
                        isActive={this.activeIndex === index}
                        heading={element.title}
                        content={element.content}
                        index={index}
                    />
                ))}
            </Host>
        )
    }
}
